import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";

const PPAttributeRuleTable = declare(Widget, {
	// store is controlled by code below 
	bResetStore: false,

	// find results by this attribute
	findAttributes: ["Node Name"],

	// available plugins
	plugins: ["find"],

	// minimal table view
	prefClass: null,
});

export = PPAttributeRuleTable;
